// extracted by mini-css-extract-plugin
module.exports = {"root":"PurchasedItem_root__6bV4y"};